import {ScreenExportScene} from "./ScreenExportScene";

// hardware elevation for a submittal: the screen (frame) export focused on the hardware.
// Same frame grid + labeled crosshairs but no plan (top-down) section, and the external
// dimensions are restricted to the outer-frame overall + door-cell overall + frame and
// door hardware offsets + hinge chain (the per-cell section sizes and stick thicknesses
// are suppressed).
export class HardwareExportScene extends ScreenExportScene {
    protected hardwareOnlyDimensions(): boolean {
        return true;
    }

    protected includeTopDown(): boolean {
        return false;
    }

    // the hardware elevation is about the hardware, not the anchors.
    protected showAnchors(): boolean {
        return false;
    }

    // the hardware elevation is about the hardware, not the glass.
    protected glassScheduleRows() {
        return [];
    }

    // a hardware elevation identifies each piece of hardware, so keep the crosshair
    // product-code labels the screen export hides.
    protected hideHardwareLabels(): boolean {
        return false;
    }
}
